(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/actions/logout-callback.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/actions/logout-callback.js');
"use strict";


svs.sportsbook.sbtech_api_impl.fns.actions.logoutCallback = post => post;

 })(window);